"use strict";
import Common from "./Common";
import SplashScene from "./SplashScene";
import ResultsScene from "./ResultsScene";
import GameScene from "./GameScene";

export default class Application {
    constructor() {
        Common.copy = Common.assets.getJSON("copy");
        //Common.config = Common.assets.getJSON("config");
    }

    init() {
        this.showSplashScene();
    }

    /**
     * @returns {Scene}
     */
    showSplashScene() {

        var scene = new SplashScene();

        scene.signals.next.add(function () {
            this.showGameScene();
        }, this);

        var transition = new p3.FadeTransition(0x0, 1.0);
        Common.scene.add(scene, transition);
        return scene;

    }

    /**
     * @returns {Scene}
     */
    showResultsScene() {

        var scene = new ResultsScene();

        scene.signals.next.add(function () {
            this.showGameScene();
        }, this);

        scene.signals.home.add(function (scene) {
            this.showSplashScene();
        }, this);

        var transition = new p3.FadeTransition(0x0, 1.0);
        Common.scene.add(scene, transition);
        return scene;

    }

    showGameScene() {
        Common.paused = false;

        var scene = new GameScene();

        scene.signals.previous.add(function (scene) {
            this.showGameScene();
        }, this);

        scene.signals.next.add(function (scene) {
            this.showResultsScene();
        }, this);

        scene.signals.home.add(function (scene) {
            this.showSplashScene();
        }, this);


        var transition = new p3.FadeTransition(0x0, 1.0);
        Common.scene.add(scene, transition);
        return scene;
    }
}